import * as React from 'react';

import 'css!./__styles__/IllustrativeTooltip';

type Props = {
  width: number;
  anchorLeft: number;
  children: React.ReactNode | React.ReactNode[];
};

const IllustrativeTooltip = ({ width, anchorLeft, children }: Props) => (
  <div className="IllustrativeTooltip" style={{ width, left: anchorLeft }}>
    {children}
    <div className="IllustrativeTooltip-Triangle" style={{ left: Math.round(width / 2 - 8) }} />
  </div>
);

export default IllustrativeTooltip;
